namespace GeniuzPOS.InitialData {
    export interface PsExchangeRateRow {
        Id?: number;
        EffectiveDate?: string;
        CurrencyCode?: string;
        ExchangeRate?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsExchangeRateRow {
        export const idProperty = 'Id';
        export const nameProperty = 'CurrencyCode';
        export const localTextPrefix = 'InitialData.PsExchangeRate';
        export const lookupKey = 'InitialData.PsExchangeRate';

        export function getLookup(): Q.Lookup<PsExchangeRateRow> {
            return Q.getLookup<PsExchangeRateRow>('InitialData.PsExchangeRate');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:สกุลเงินและอัตราแลกเปลี่ยน:อัตราแลกเปลี่ยน:Delete';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:สกุลเงินและอัตราแลกเปลี่ยน:อัตราแลกเปลี่ยน:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:สกุลเงินและอัตราแลกเปลี่ยน:อัตราแลกเปลี่ยน:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:สกุลเงินและอัตราแลกเปลี่ยน:อัตราแลกเปลี่ยน:Modify';

        export declare const enum Fields {
            Id = "Id",
            EffectiveDate = "EffectiveDate",
            CurrencyCode = "CurrencyCode",
            ExchangeRate = "ExchangeRate",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
